import { Protocol } from "./types";

export const checkIsProtocolInvalid = 
    (url: string): boolean => url?.startsWith(Protocol.HTTPS);